import { app } from '../../../app';

app.factory('RegistrationProfile', RegistrationProfile);

/** @ngInject */
function RegistrationProfile($resource) {
    return $resource('app/rest/registrationprofiles/:id', {}, {
        'copyProfile' : {
            method : 'POST',
            url : 'app/rest/registrationprofiles/copy?id=:id',
            params : {
                id : '@id'
            }
        },
        'updateProfile' : {
            method : 'PUT',
        },
        'getProfilePhoto' : {
            method : 'GET',
            url : 'app/rest/registrationprofiles/:id/profilephoto',
            params : {
                id : '@id'
            }
        },
        'importFacebookProfile' : {
            method : 'POST',
            url : 'app/rest/registrationprofiles/import'
        },
        'setDefault' : {
            method: 'POST',
            url: 'app/rest/registrationprofiles/:id/setdefault',
            isArray: true,
            params : {
                id : '@id'
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profiles.service.js